export const queryString = (name:string) => {
  const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));
  return urlParams.get(name)?.replace(' ', '+');
}

export const getLoginReturnUrl = () => {
  return window.location.protocol + '//' + window.location.host + window.location.pathname + '/' ;
}

export const getQueryStringParam = (surl: string, name:string) => {
  const url = new URL(surl);
  return  url.searchParams.get(name);
}

export const getQueryStringJson = (surl: string) => {
  return JSON.parse(decodeURIComponent(surl.split('?')[1]));
}

export const isEdge = () => {
  return window.location.host.indexOf('edge.') > -1 || window.location.host.indexOf('localhost') > -1; //localhost equals edge assets
}